/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_RequiredInputs */

const en_dialog_premium_required = /** @type {(inputs: Dialog_Premium_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium plan required`)
};

const es_dialog_premium_required = /** @type {(inputs: Dialog_Premium_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se requiere plan Premium`)
};

/**
* | output |
* | --- |
* | "Premium plan required" |
*
* @param {Dialog_Premium_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_required = /** @type {((inputs?: Dialog_Premium_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_required(inputs)
	return en_dialog_premium_required(inputs)
});